/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const EthernetIconConfig = {
  name: 'EthernetIcon',
  height: 512,
  width: 512,
  svgPath: 'M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(EthernetIconConfig);
//# sourceMappingURL=ethernet-icon.js.map